type AnyFunc = (...args: unknown[]) => unknown;

export function debounce<T extends AnyFunc>(func: T, wait = 0) {
  let timeout: ReturnType<typeof setTimeout> | undefined;

  return function(this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = undefined;
      func.apply(this, args);
    }, wait);
  }
}